import { useEffect, useState } from "react";
import { Typography, Box, Stack, Grid, Snackbar, Button, IconButton } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import BuildIcon from '@mui/icons-material/Build';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import * as api from '../../api/Defect'
import { ModalError } from "../../ui-component";
import * as dict from '../../dictionary'
import { BackDropLoading } from "../../ui-component";
import { checkBase64 } from "../../utils/checkBase64";
import { showUnit } from "../../utils/showUnit";
export const FastCare = () => {
    const domain = window.location.origin
    const theme = useTheme()
    const location = useLocation()
    const navigate = useNavigate()
    document.title = "Fast Care"
    document.icon = "https://api.faviconkit.com/stackoverflow.com/24"
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [openDialogAddPWA, setOpenDialogAddPWA] = useState(false);
    const [loading, setLoading] = useState(false)
    const [projectInfoTemp, setProjectInfoTemp] = useState(null);
    const [modalError, setModalError] = useState({
        open: false,
        error: {
            status: "",
            message: ""
        }
    });
    const [unitInfo, setUnitInfo] = useState({
        project_name_en: "",
        project_name_th: "",
        unit_code: "",
        unit_no: ""
    })



    const getInfo = async (projectInfo) => {
        setLoading(true)
        setProjectInfoTemp(projectInfo)
        let res = await api.getUnitInfoFastCare({
            client_id: projectInfo.client_id,
            client_url: projectInfo.client_url,
            unit_id: projectInfo.unit_id,
            project_id: projectInfo.project_id
        })

        if (res.status !== 200) {
            setModalError({
                open: true,
                error: {
                    status: res.response.status,
                    message: dict.Cannot_Found_UnitInfoId_TXT["th"]
                }
            })
            setLoading(false)
            return
        }

        setUnitInfo(res.data?.result)
        setLoading(false)
        return
    }

    const titleCondition = () => {
        if (projectInfoTemp?.client_type !== "RENTAL") {

            return language === "th" ? "ยินดีต้อนรับสู่ FAST Care" : "Welcome to FAST Care"

        }

        if (projectInfoTemp?.client_type === "RENTAL") {

            return language === "th" ? "ยินดีต้อนรับสู่ FAST Staff" : "Welcome to FAST Staff"

        }

    }

    const handleCloseDialog = () => {
        setOpenDialogAddPWA(false)
    }

    const handleAddPWA = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    }

    useEffect(() => {
        let params = new URLSearchParams(location.search);
        let unitText = params.get("unitText")
        let projectInfo
        if (checkBase64(unitText)) {
            projectInfo = window.atob(unitText)
        }

        getInfo({
            client_id: parseInt(projectInfo?.split("|")[0]) || null,
            client_url: projectInfo?.split("|")[1] || null,
            project_id: parseInt(projectInfo?.split("|")[2]) || null,
            unit_id: parseInt(projectInfo?.split("|")[3]) || null,
            client_type: projectInfo?.split("|")[4] || null,
        })

    }, [])

    useEffect(() => {
        // manifest สำหรับ pwa ของ fastcare
        var myDynamicManifest = {
            "short_name": "FAST Care",
            "name": "FAST Care PWA",
            "icons": [
                {
                    "src": domain + "/fast_icon.png",
                    "sizes": "64x64 32x32 24x24 16x16",
                    "type": "image/x-icon"
                },
                {
                    "src": domain + "/fast_icon.png",
                    "type": "image/png",
                    "sizes": "192x192"
                },
                {
                    "src": domain + "/fast_icon.png",
                    "type": "image/png",
                    "sizes": "512x512"
                }
            ],
            "start_url": domain + "/fastcare" + location.search,
            "display": "standalone",
            "theme_color": "#000000",
            "background_color": "#ffffff"
        }

        const stringManifest = JSON.stringify(myDynamicManifest);
        const blob = new Blob([stringManifest], { type: 'application/json' });
        const manifestURL = URL.createObjectURL(blob);
        document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);

        // เปลี่ยนไอคอน browser
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = domain + "/fast-favicon.ico";
        //=====================
    }, [])


    useEffect(() => {
        sessionStorage.removeItem("tabSelected") // ลบ tabSelected จากหน้า detail 

        const handler = e => {
            e.preventDefault();
            setSupportsPWA(true);
            setPromptInstall(e);
            setOpenDialogAddPWA(true)
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    useEffect(() => {
        localStorage.clear()
        sessionStorage.setItem("fast-lang", sessionStorage.getItem("fast-lang") || "th")

    }, [])


    const action = (
        <>
            <Button color="secondary" size="small" onClick={handleAddPWA}>
                {dict.ADD_TXT[sessionStorage.getItem("fast-lang")]}
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseDialog}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );


    const [language, setLanguage] = useState(sessionStorage.getItem("fast-lang") || "th");

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        sessionStorage.setItem("fast-lang", lang)
    };

    return <>
        <BoxBackground sx={{ minHeight: "calc(100dvh)" }} >
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100dvh - 90px)" }}>
                <Box sx={{ background: "rgb(255,255,255, .7)", borderRadius: "50px", padding: "50px" }}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 4 }}>
                        <Box
                            sx={{
                                display: "flex",
                                borderRadius: "30px",
                                overflow: "hidden",
                                border: `1px solid ${theme.palette.primary.main}`,
                                backgroundColor: "white",
                            }}
                        >
                            <Button
                                onClick={() => handleLanguageChange("th")}
                                sx={{
                                    borderRadius: 0,
                                    minWidth: "60px",
                                    backgroundColor: language === "th" ? theme.palette.primary.main : "white",
                                    color: language === "th" ? "white" : theme.palette.primary.main,
                                    fontWeight: 700,
                                    "&:hover": {
                                        backgroundColor: language === "th" ? theme.palette.primary.dark : "rgba(0,0,0,0.04)",
                                    },
                                }}
                            >
                                TH
                            </Button>
                            <Button
                                onClick={() => handleLanguageChange("en")}
                                sx={{
                                    borderRadius: 0,
                                    minWidth: "60px",
                                    backgroundColor: language === "en" ? theme.palette.primary.main : "white",
                                    color: language === "en" ? "white" : theme.palette.primary.main,
                                    fontWeight: 700,
                                    "&:hover": {
                                        backgroundColor: language === "en" ? theme.palette.primary.dark : "rgba(0,0,0,0.04)",
                                    },
                                }}
                            >
                                EN
                            </Button>
                        </Box>
                    </Box>
                    <Stack direction={"column"}>
                        <Grid container spacing={1} >
                            <Grid item xs={12} container justifyContent={"center"}>
                                <Typography fontSize={20} fontWeight={700} >
                                    {titleCondition()}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} container >
                                <Grid item xs={6} sx={{ textAlign: 'right' }} >
                                    <Typography>{language === "th" ? "โครงการ" : "Project"}&nbsp;:</Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ wordWrap: "break-word" }}>
                                    <Typography>&nbsp;{unitInfo?.["project_name_" + language]}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container>
                                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                                    <Typography>{language === "th" ? "หมายเลขยูนิต" : "Unit Code"}&nbsp;:</Typography>
                                </Grid>
                                <Grid item xs={6} sx={{ wordWrap: "break-word" }}>
                                    <Typography>&nbsp;{ showUnit(unitInfo?.unit_code,unitInfo?.unit_no)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Box sx={{ display: "flex", justifyContent: "center" }} mt={5}>
                            <Stack spacing={3} alignItems="start">
                                <Stack direction={"row"} spacing={3}>
                                    <Box onClick={() => {
                                        sessionStorage.setItem("houseNo", JSON.stringify({ unit_code: unitInfo?.unit_code , unit_no: unitInfo?.unit_no }))
                                        navigate("/fastcare/formAdd" + location.search)
                                    }}>
                                        <Stack
                                            direction="column"
                                            alignItems="center"
                                            justifyContent={"center"}
                                            spacing={1}
                                        >
                                            <Box sx={{
                                                height: "8em", width: "8em",
                                                textAlign: "center", alignItems: "center",
                                                display: "flex", justifyContent: "center",
                                                border: "1px",
                                                borderRadius: "12px",
                                                boxShadow: "5px 5px 7px 0px #00000040",
                                                backgroundColor: theme.palette.primary.main
                                            }}>
                                                <Box >
                                                    <BuildIcon sx={{ color: "white" }} />
                                                    <Box sx={{ textAlign: "center" }}>
                                                        <Typography variant="caption" sx={{ wordWrap: "break-word", color: "white" }}>
                                                            {language === "th" ? "แจ้งซ่อม" : "Report Issue"}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Stack>
                                    </Box>

                                    <Box onClick={() => navigate("/fastcare/list" + location.search + "&unitNo=" + encodeURIComponent(unitInfo?.unit_no) +"&unitCode=" + encodeURIComponent(unitInfo?.unit_code), { state: { formWelcome: true } })}>
                                        <Stack
                                            direction="column"
                                            alignItems="center"
                                            justifyContent={"center"}
                                            spacing={1}
                                        >
                                            <Box sx={{
                                                height: "8em", width: "8em",
                                                textAlign: "center", alignItems: "center",
                                                display: "flex", justifyContent: "center",
                                                border: "1px",
                                                borderRadius: "12px",
                                                boxShadow: "5px 5px 7px 0px #00000040",
                                                backgroundColor: theme.palette.primary.main
                                            }}>
                                                <Box >
                                                    <ListAltOutlinedIcon sx={{ color: "white" }} />
                                                    <Box sx={{ textAlign: "center" }}>
                                                        <Typography variant="caption" sx={{ wordWrap: "break-word", color: "white" }}>
                                                            {language === "th" ? "รายการแจ้งซ่อม" : "Repair List"}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Stack>
                                    </Box>

                                </Stack>
                                {
                                    projectInfoTemp?.client_type === "RENTAL" && <Stack direction={"row"} spacing={3}>
                                        <Box onClick={() => navigate("/service-request" + location.search, { state: { formWelcome: true, projectInfo: projectInfoTemp } })}>
                                            <Stack
                                                direction="column"
                                                alignItems="center"
                                                justifyContent={"center"}
                                                spacing={1}
                                            >
                                                <Box sx={{
                                                    height: "8em", width: "8em",
                                                    textAlign: "center", alignItems: "center",
                                                    display: "flex", justifyContent: "center",
                                                    border: "1px",
                                                    borderRadius: "12px",
                                                    boxShadow: "5px 5px 7px 0px #00000040",
                                                    backgroundColor: theme.palette.primary.main
                                                }}>
                                                    <Box >
                                                        <ListAltOutlinedIcon sx={{ color: "white" }} />
                                                        <Box sx={{ textAlign: "center" }}>
                                                            <Typography variant="caption" sx={{ wordWrap: "break-word", color: "white" }}>
                                                                {language === "th" ? "แจ้ง Service Request" : "Create Service Request"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Box>
                                        <Box onClick={() => navigate("/service-request/list" + location.search + "&unitNo=" + (unitInfo?.unit_no || unitInfo?.unit_code), { state: { formWelcome: true, projectInfo: projectInfoTemp } })}>
                                            <Stack
                                                direction="column"
                                                alignItems="center"
                                                justifyContent={"center"}
                                                spacing={1}
                                            >
                                                <Box sx={{
                                                    height: "8em", width: "8em",
                                                    textAlign: "center", alignItems: "center",
                                                    display: "flex", justifyContent: "center",
                                                    border: "1px",
                                                    borderRadius: "12px",
                                                    boxShadow: "5px 5px 7px 0px #00000040",
                                                    backgroundColor: theme.palette.primary.main
                                                }}>
                                                    <Box >
                                                        <ListAltOutlinedIcon sx={{ color: "white" }} />
                                                        <Box sx={{ textAlign: "center" }}>
                                                            <Typography variant="caption" sx={{ wordWrap: "break-word", color: "white", whiteSpace: 'pre-line' }}>
                                                                {language === "th" ? "รายการ\nService Request" : "Service Request List"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Box>
                                    </Stack>
                                }

                            </Stack>
                        </Box>
                    </Stack>
                </Box>
            </Box>
            <ModalError
                onClose={() => setModalError(false)}
                open={modalError?.open}
                error={modalError?.error}
            />
            <BackDropLoading loading={loading} />
        </BoxBackground>

        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={openDialogAddPWA}
            // onClose={handleCloseDialog}
            action={action}
            disableWindowBlurListener={false}
            message={language === "th" ? "ต้องการเพิ่มหน้านี้ไว้บนหน้าจอหรือไม่?" : "Do you want to add this page to your home screen?"}
        />
    </>
}

const BoxBackground = styled(Box)({

    // background: "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(195,214,233,1) 100%) no-repeat",

    // borderRadius: "5%"
})

const BoxImg = styled(Box)({

})